var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('result',{attrs:{"is-success":true,"description":_vm.description,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }